<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
            <li><router-link to="/">HARUMIFLAG</router-link></li>
            <li v-if="informationDetail.acf?.title != ''"><router-link :to="'/information/' + informationDetail.id">{{ informationDetail.acf?.title }}</router-link></li>
            <li v-else><router-link :to="'/information/' + informationDetail.id">{{ informationDetail.acf?.explanation }}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="info-detail">
      <div class="info-detail__cont">
        <div class="container">
          <div class="info-detail__holder">
            <h2 class="page--title" v-if="!isLoading">
              INFORMATION<span>インフォメーション</span>
            </h2>
            <div class="skeleton-parent" v-if="isLoading">
              <PuSkeleton style="height: 60px;" :count="1"/>
            </div>
            <div class="cont-top" :class="informationNewsUrl.length  === 0 ? 'cont-top-custom' : ''">
              <div class="text-top" v-if="informationDetail.acf?.start_date && !isLoading">
                公開日：
                <span>{{ formatDate(informationDetail.acf?.start_date) }}</span>
                ({{formatWeekDay(informationDetail.acf?.start_date)}})
              </div>
              <div class="skeleton-parent" v-if="isLoading">
                <PuSkeleton :count="1"/>
              </div>
              <h2 v-if="informationDetail.acf?.title && !isLoading">
                {{ informationDetail.acf?.title }}
              </h2>
              <div class="skeleton-parent" v-if="isLoading" style="margin: 5px 0;">
                <PuSkeleton style="height: 20px;" :count="2"/>
              </div>
              <ul class="list-tag" v-if="informationDetail.acf?.category || informationDetail.acf?.contributor && !isLoading">
                <li v-if="informationDetail.acf?.category">{{ informationDetail.acf?.category }}</li>
                <li v-if="informationDetail.acf?.contributor">{{ informationDetail.acf?.contributor }}</li>
              </ul>
              <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 30px;">
                <PuSkeleton style="height: 20px;" :count="1"/>
              </div>
              <div v-if="informationDetail.acf?.explanation" class="cont-text mb-custom">
                <p v-html="informationDetail.acf?.explanation" v-if="informationDetail.acf?.explanation && !isLoading"></p>
                <div class="skeleton-parent" v-if="isLoading">
                  <PuSkeleton :count="5"/>
                </div>
              </div>
              <div
                class="cont-leaflets"
                v-if="
                  (informationDetail.acf?.file1 &&
                  informationDetail.acf?.file_name1) ||
                  (informationDetail.acf?.file2 &&
                  informationDetail.acf?.file_name2) ||
                  (informationDetail.acf?.file3 &&
                  informationDetail.acf?.file_name3) ||
                  (informationDetail.acf?.file4 && 
                  informationDetail.acf?.file_name4) ||
                  (informationDetail.acf?.file5 &&
                  informationDetail.acf?.file_name5) && !isLoading">
                <h3>お知らせ</h3>
                <ul>
                  <li v-if="informationDetail.acf?.file1 && informationDetail.acf?.file_name1">
                    <a target="_blank" :href="$func.formatUrl(informationDetail.acf?.file1)">{{ informationDetail.acf?.file_name1 }}</a>
                  </li>
                  <li v-if="informationDetail.acf?.file2 && informationDetail.acf?.file_name2">
                    <a target="_blank" :href="$func.formatUrl(informationDetail.acf?.file2)">{{ informationDetail.acf?.file_name2 }}</a>
                  </li>
                  <li v-if="informationDetail.acf?.file3 && informationDetail.acf?.file_name3">
                    <a target="_blank" :href="$func.formatUrl(informationDetail.acf?.file3)">{{ informationDetail.acf?.file_name3 }}</a>
                  </li>
                  <li v-if="informationDetail.acf?.file4 && informationDetail.acf?.file_name4">
                    <a target="_blank" :href="$func.formatUrl(informationDetail.acf?.file4)">{{ informationDetail.acf?.file_name4 }}</a>
                  </li>
                  <li v-if="informationDetail.acf?.file5 && informationDetail.acf?.file_name5">
                    <a target="_blank" :href="$func.formatUrl(informationDetail.acf?.file5)">{{ informationDetail.acf?.file_name5 }}</a>
                  </li>
                </ul>
              </div>
              <div class="skeleton-parent" v-if="isLoading">
                <PuSkeleton :count="5"/>
              </div>
            </div>
          </div>
        </div>
        <div class="cont-bottom">
          <div class="container">
            <div class="info-detail__holder">
              <div class="info-list" v-if="informationNewsUrl.length != 0 && (informationNewsUrl[0] || informationNewsUrl[1])">
                <fragment
                  v-for="(item, index) in informationNewsUrl"
                  :key="index"
                >
                  <div class="info-list__item" v-if="index <= 1" :style="[item == null ? {'background': 'none'} : {'background': '#fff'}]">
                    <div v-if="item != null">
                      <router-link
                        class="item-parent"
                        :to="'/information/' + item.id"
                      >
                        <div class="item-child">
                          <div
                            class="item-status"
                            v-if="diffDate(item.acf?.start_date + ' ' + item.acf?.start_time) <= 7"
                          >
                            <img src="@/assets/img/top/portal_icon.svg" alt="portal_icon" />
                            <div class="item-status__text">NEW</div>
                          </div>
                          <ul :class="diffDate(item.acf?.start_date + ' ' + item.acf?.start_time) <= 7 ? 'show_status' : 'list-tag'" v-if="item.acf?.category || item.acf?.contributor">
                            <li v-if="item.acf?.category">{{ item.acf?.category }}</li>
                            <li v-if="item.acf?.contributor">{{ item.acf?.contributor }}</li>
                          </ul>
                          <p v-if="item.acf?.title" v-html="item.acf?.title"></p>
                          <div class="date" v-if="item.acf?.start_date">
                            公開日：
                            <span>{{ formatDate(item.acf?.start_date) }}</span>
                            ({{formatWeekDay(item.acf?.start_date)}})
                          </div>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </fragment>

                <fragment
                  v-for="(item, index) in informationNewsUrl"
                  :key="index"
                > 
                  <div class="info-list__item" v-if="index === 0 && (informationNewsUrl.length != 0 && (informationNewsUrl[0] || informationNewsUrl[1]))">
                    <div class="btn-pre" v-if="item != null">
                      <router-link :to="'/information/' + item.id"><img src="@/assets/img/info-detail/info-top-icon-pre.svg" alt="info-top-icon-pre"/>前の記事を見る</router-link>
                    </div>
                  </div>
                  <div class="info-list__item" v-if="index === 1 && (informationNewsUrl.length != 0 && (informationNewsUrl[0] || informationNewsUrl[1]))">
                    <div class="btn-next" v-if="item != null">
                      <router-link :to="'/information/' + item.id">次の記事を見る<img src="@/assets/img/info-detail/info-top-icon-next.svg" alt="info-top-icon-next"/></router-link>
                    </div>
                  </div>
                </fragment>
              </div>
              <div class="btn-list">
                <router-link to="/information">一覧へ戻る</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Fragment } from "vue-fragment";
import { getUrl, formatDate, formatWeekDay, diffDate, metaData, getItemNextPrev } from '@/utils/helper';
import CONSTANT from "@/constant";
import router from "@/router";

export default {
  name: "InformationDetail",
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Fragment,
  },

  data() {
    return {
      informationDetail: [],
      informationNewsUrl: [],
      dataFilter: CONSTANT.dataFilter[0],
      isLoading: true,
    };
  },
  computed: {},
  methods: {
    formatDate,
    formatWeekDay,
    diffDate,
    getItemNextPrev
  },
  created() {
    this.isLoading = true
    getUrl(`/information/${this.$route.params.id}`)
    .then((response) => {
      let deliveryMedia = response.data.acf?.delivery_media;
      if(deliveryMedia.includes(this.dataFilter.town)) {
        this.informationDetail = response.data;
      } else {
        this.$router.push('/timeout')
      }

        metaData(
          `${this.informationDetail.acf?.title ? this.informationDetail.acf?.title : ''} | HARUMIFLAGタウンポータル`,
          '',
          'HARUMIFLAGタウンポータル',
          'article',
        )

      this.isLoading = false 
    })
    .catch((e) => {
      console.log(e);
      this.$router.push('/NotFound')
    });

      this.isLoading = true
      getUrl('/information')
      .then((response) => { 
        const dataInforFilter = this.$func.filterByDeliveryMedia(response.data);
        this.informationNewsUrl = this.getItemNextPrev(dataInforFilter,this.$route.params.id );
        this.isLoading = false
      })
      .catch((e) => {
        console.log(e);
      });
  },
};
</script>
